import React from 'react';
import { Link } from 'react-router-dom';
import { Sun, Instagram, Facebook, Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#4E1225] text-[#E9DCC6] pt-16 pb-8 border-t border-[#E7D9BC]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Main Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8 pb-12 border-b border-[#E9DCC6]/15">
          
          {/* Brand Column - Span 4 */}
          <div className="lg:col-span-4 space-y-4">
            <Link to="/" className="inline-flex items-center space-x-3 group">
              <div className="w-11 h-11 rounded-2xl bg-gradient-to-br from-[#FF7B00] to-[#D4AF37] flex items-center justify-center shadow-lg transition-all duration-300 group-hover:scale-105 flex-shrink-0">
                <span className="text-white font-serif-heading font-bold text-2xl relative z-10">प</span>
              </div>
              <div>
                <span className="font-serif-heading text-2xl font-bold tracking-tight text-[#FBF4E7] group-hover:text-[#E8D5A8] transition-colors">
                  Paramparik
                </span>
                <div className="text-[10px] font-bold tracking-[0.3em] text-[#E8D5A8] uppercase -mt-1">Sacred Traditions</div>
              </div>
            </Link>

            <p className="text-xs text-[#C9B79A] leading-relaxed max-w-sm">
              Authentic, hand-blessed puja essentials — bracelets, malas, pendants and puja samagri — delivered across India with care.
            </p>

            {/* Social Icons */}
            <div className="flex items-center space-x-3 pt-2">
              <a
                href="#"
                aria-label="Instagram"
                className="w-9 h-9 rounded-full border border-[#E9DCC6]/30 flex items-center justify-center text-[#E9DCC6] hover:bg-[#B98B3E] hover:text-[#4E1225] hover:border-[#B98B3E] transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="#"
                aria-label="Facebook"
                className="w-9 h-9 rounded-full border border-[#E9DCC6]/30 flex items-center justify-center text-[#E9DCC6] hover:bg-[#B98B3E] hover:text-[#4E1225] hover:border-[#B98B3E] transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href="#"
                aria-label="Contact"
                className="w-9 h-9 rounded-full border border-[#E9DCC6]/30 flex items-center justify-center text-[#E9DCC6] hover:bg-[#B98B3E] hover:text-[#4E1225] hover:border-[#B98B3E] transition-colors"
              >
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Shop Column - Span 2 */}
          <div className="lg:col-span-2 lg:col-start-6">
            <h4 className="font-body text-xs font-semibold text-[#FBF4E7] uppercase tracking-wider mb-4">
              Shop
            </h4>
            <ul className="space-y-2.5 text-xs text-[#C9B79A]">
              <li><Link to="/store" className="hover:text-[#E8D5A8] transition-colors">Bracelets</Link></li>
              <li><Link to="/store" className="hover:text-[#E8D5A8] transition-colors">Rudraksha & Mala</Link></li>
              <li><Link to="/store" className="hover:text-[#E8D5A8] transition-colors">Pendants</Link></li>
              <li><Link to="/store" className="hover:text-[#E8D5A8] transition-colors">Puja Samagri</Link></li>
            </ul>
          </div>

          {/* Customer Care - Span 2 */}
          <div className="lg:col-span-2">
            <h4 className="font-body text-xs font-semibold text-[#FBF4E7] uppercase tracking-wider mb-4">
              Customer Care
            </h4>
            <ul className="space-y-2.5 text-xs text-[#C9B79A]">
              <li><Link to="/dashboard" className="hover:text-[#E8D5A8] transition-colors">Track Order</Link></li>
              <li><Link to="/store" className="hover:text-[#E8D5A8] transition-colors">Shipping Policy</Link></li>
              <li><Link to="/store" className="hover:text-[#E8D5A8] transition-colors">Returns & Refunds</Link></li>
              <li><Link to="/store" className="hover:text-[#E8D5A8] transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Stay Connected - Span 4 */}
          <div className="lg:col-span-3">
            <h4 className="font-body text-xs font-semibold text-[#FBF4E7] uppercase tracking-wider mb-2">
              Stay Connected
            </h4>
            <p className="text-xs text-[#C9B79A] mb-3">
              Get updates on new arrivals & festive offers
            </p>

            <form onSubmit={(e) => e.preventDefault()} className="flex gap-2 max-w-sm">
              <input
                type="email"
                placeholder="Your email address"
                className="flex-1 bg-white/5 border border-[#E9DCC6]/30 rounded-md px-3.5 py-2.5 text-xs text-[#FBF4E7] placeholder-[#B8A585] focus:outline-none focus:border-[#B98B3E]"
              />
              <button
                type="submit"
                className="px-4 py-2.5 rounded-md bg-[#B98B3E] text-[#4E1225] font-bold text-xs hover:bg-[#E8D5A8] transition-colors"
              >
                Join
              </button>
            </form>
          </div>

        </div>

        {/* Footer Bottom Bar */}
        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#B8A585]">
          <span>© 2026 Paramparik Puja. All rights reserved.</span>

          {/* Payment Badges */}
          <div className="flex items-center gap-2">
            {['UPI', 'Cards', 'Net Banking', 'COD'].map((pay) => (
              <span key={pay} className="px-2.5 py-1 border border-[#E9DCC6]/25 rounded text-[10.5px] font-medium tracking-wide">
                {pay}
              </span>
            ))}
          </div>

          {/* Legal Links */}
          <div className="flex items-center space-x-4">
            <Link to="#" className="hover:text-[#E9DCC6] transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-[#E9DCC6] transition-colors">Terms of Service</Link>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
